import "core-js/stable";
import "regenerator-runtime/runtime";
import { createRoot } from 'react-dom/client';
import { AppContainer } from "./containers/app/app-container"
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./utils/datadog-util";
import "react-international-phone/style.css";

const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        { /** @ts-ignore */}
        <BrowserRouter>
            <AppContainer />
        </BrowserRouter>
    </Provider>
);


if (process.env.NODE_ENV !== "production" && module.hot) {
    module.hot.accept(() => {
        root.render(
            <Provider store={store}>
                { /** @ts-ignore */}
                <BrowserRouter>
                    <AppContainer />
                </BrowserRouter>
            </Provider>
        );
    })
}